import React, { useState, useEffect } from 'react';
import Card from './Card';

function AllCards() {
  const [cards, setCards] = useState([]);
  const API = process.env.REACT_APP_API;

  useEffect(() => {
    async function fetchCards() {
      try {
        const cardSet = localStorage.getItem('cardSet') || 'v1';
        const endpoint = `${API}/card/getCards?cardSet=${cardSet}`;

        const response = await fetch(endpoint);
        const data = await response.json();

        // Sort the cards by palette number
        const sortedCards = data.sort((a, b) => a.paletteNumber - b.paletteNumber);
        setCards(sortedCards);
      } catch (error) {
        console.error('Error fetching cards:', error);
      }
    }
    fetchCards();
  }, [API]);

  return (
    <div>
      {cards.map(card => (
        <Card key={card.paletteNumber} card={card} />
      ))}
    </div>
  );
}

export default AllCards;
